export default __webpack_public_path__ + "static/media/cylinder.e20de7b6.svg";